import * as React from 'react';
import * as dateFns from 'date-fns';
import * as styles from './styles.scss';
import { AccountRoutes, BoardRoutes, Routes } from 'constants/routes';
import { IPopUpData } from 'interfaces/reducers';
import { IState } from 'redux/global-reducers';
import { Link } from 'react-router-dom';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { changeRoute } from './actions';
import {
  closeConfirmDebtModal,
  closeOtpModal,
  closeOtpModalAndTriggerConfirmDebt,
  closePopUpSlideModal,
  dispatchPopUptoStore,
  getBuyInStockList,
  getTokenCA,
  queryClientDetail,
  setCurrentSymbol,
  showNotification,
  toggleSymbolInfoModal,
} from 'redux/global-actions';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { queryEquityConfirmDebt } from 'components/areas/Account/LoadDetail/ConfirmDebt/action';
import { withErrorBoundary } from 'react-error-boundary';
import Fallback from '../Fallback';
import FooterSection from '../FooterSection';
import Modal from '../Modal';
import ModalSlider from '../ModalSlider';
import NavBar from '../NavBar';
import OtpModal from '../OtpModal';
import SideBarFunction from '../SideBarFunction';
import SymbolInfo from '../SymbolInfo';
import config from 'config';
import { queryLimitDate } from 'redux/global-actions/QueryLimitDate';
import {
  checkConsent,
  doConsent,
  resetConsent,
} from 'redux/global-actions/Consent';
import { queryWordBanner } from 'redux/global-actions/QueryWordBanner';
import { DEVICEID } from 'constants/main';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import classNames from 'classnames';
import { getKey, setKey } from 'utils/localStorage';
import { Market, MarketStatus } from 'constants/enum';
import { vnpt_plugin } from './vnpt-plugin';
import { registerTokenCA } from 'redux/global-actions/RegisterTokenCA';
import { PolicyBanner } from 'assets/svg';
import { IDoConsentParams } from 'interfaces/api';
import { LICENSE_KEY_VNPT } from './vnpt-license-key';

export interface ILayoutProps
  extends React.ClassAttributes<LayoutComponent>,
    WithNamespaces,
    RouteComponentProps {
  readonly route: Routes;
  readonly symbolInfoModal: IState['symbolInfoModal'];
  readonly otp: IState['otp'];
  readonly otpToken: IState['otpToken'];
  readonly isAuthenticated: IState['isAuthenticated'];
  readonly selectedAccount: IState['selectedAccount'];
  readonly equityConfirmDebt: IState['equityConfirmDebt'];
  readonly confirmDebtModal: IState['confirmDebtModal'];
  readonly dataPopUpto: IState['dispatchPopUptoStore'];
  readonly config: IState['config'];
  readonly lang: IState['lang'];
  readonly limitDateQuery: IState['limitDateQuery'];
  readonly wordBannerQuery: IState['wordBannerQuery'];
  readonly isConsent: IState['isConsent'];
  readonly clientDetail: IState['clientDetail'];
  readonly marketStatus: IState['marketStatus'];
  readonly tokenCA: IState['tokenCA'];
  readonly doConsentResult: IState['doConsentResult'];

  readonly setCurrentSymbol: typeof setCurrentSymbol;
  readonly changeRoute: typeof changeRoute;
  readonly toggleSymbolInfoModal: typeof toggleSymbolInfoModal;
  readonly closeOtpModal: typeof closeOtpModal;
  readonly queryEquityConfirmDebt: typeof queryEquityConfirmDebt;
  readonly closeConfirmDebtModal: typeof closeConfirmDebtModal;
  readonly closeOtpModalAndTriggerConfirmDebt: typeof closeOtpModalAndTriggerConfirmDebt;
  readonly dispatchPopUptoStore: typeof dispatchPopUptoStore;
  readonly closePopUpSlideModal: typeof closePopUpSlideModal;
  readonly queryLimitDate: typeof queryLimitDate;
  readonly queryWordBanner: typeof queryWordBanner;
  readonly checkConsent: typeof checkConsent;
  readonly doConsent: typeof doConsent;
  readonly resetConsent: typeof resetConsent;
  readonly queryClientDetail: typeof queryClientDetail;
  readonly showNotification: typeof showNotification;
  readonly getBuyInStockList: typeof getBuyInStockList;
  readonly registerTokenCA: typeof registerTokenCA;
  readonly getTokenCA: typeof getTokenCA;
}

interface ILayoutStates {
  readonly isConfirmDebt?: boolean;
  readonly isShowPopUps: boolean;
  readonly isShowPolicy: boolean;
  readonly deviceIp: string;
  readonly isShowPolicyDetail: boolean;
}
class LayoutComponent extends React.Component<ILayoutProps, ILayoutStates> {
  constructor(props: ILayoutProps) {
    super(props);

    this.state = {
      isShowPopUps: true,
      isConfirmDebt: true,
      isShowPolicy: false,
      deviceIp: '',
      isShowPolicyDetail: false,
    };
  }

  componentDidMount() {
    //getDeviceId
    if (getKey(DEVICEID) == null || getKey(DEVICEID) === '') {
      FingerprintJS.load()
        .then((fp) => {
          return fp.get();
        })
        .then((result) => {
          this.setState({ deviceIp: result.visitorId });
          setKey(DEVICEID, result.visitorId);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.setState({ deviceIp: getKey(DEVICEID) ?? '' });
    }
    this.props.changeRoute(this.props.location.pathname);
    if (this.props.selectedAccount?.account && this.props.isAuthenticated) {
      this.props.queryClientDetail({
        clientID: this.props.selectedAccount?.username,
      });
    }
    this.props.queryWordBanner();
    if (this.props.isAuthenticated) {
      this.getInfoPopUp();
      this.props.queryLimitDate();
      this.props.checkConsent();
      //set license key when check plugin success
      vnpt_plugin.checkPlugin()?.then(function (data) {
        if (data === '1') {
          vnpt_plugin
            .setLicenseKey(LICENSE_KEY_VNPT)
            ?.then(function (data) {
              // console.log({ data });
            })
            .catch(function (e) {
              console.log(e);
            });
        }
      });
    } else {
      this.props.resetConsent();
    }
  }

  componentDidUpdate(prevProps: ILayoutProps, prevState: ILayoutStates) {
    //add funtion of click event for element more-btn
    document.getElementById('more-btn')?.addEventListener('click', () => {
      this.setState({ isShowPolicyDetail: true });
    });
    if (
      this.props.isConsent !== prevProps.isConsent &&
      this.props.isConsent.data &&
      this.props.isConsent.data?.consented !== true
    ) {
      this.setState({ isShowPolicy: true });
    }
    if (
      this.props.doConsentResult != prevProps.doConsentResult &&
      this.props.doConsentResult.data?.consented
    ) {
      this.setState({ isShowPolicy: false });
    }
    if (this.props.location !== prevProps.location) {
      this.props.changeRoute(this.props.location.pathname);
    }
    if (
      this.props.selectedAccount != prevProps.selectedAccount &&
      this.props.isAuthenticated &&
      this.props.selectedAccount
    ) {
      this.props.queryClientDetail({
        clientID: this.props.selectedAccount?.username,
      });
    }

    if (
      this.props.marketStatus != prevProps.marketStatus &&
      this.props.marketStatus.find((val) => val.market === Market.HOSE)
        ?.status === MarketStatus.ATO
    ) {
      this.props.getBuyInStockList({ marketID: 'ALL' });
    }
  }

  render() {
    const {
      t,
      dataPopUpto,
      isAuthenticated,
      isConsent,
      doConsentResult,
    } = this.props;

    const isConsented =
      isConsent.data?.consented === true ||
      (isConsent.data == null &&
        (isConsent.status.isFailed || isConsent.status.isSucceeded)) ||
      doConsentResult.data?.consented;
    return (
      <main className={this.props.config.domain}>
        {this.props.route !== Routes.LOGIN && (
          <NavBar route={this.props.route} />
        )}
        <div className={styles.Container}>
          <div className={styles.Children}>{this.props.children}</div>
          {this.props.route !== Routes.LOGIN && this.props.isAuthenticated && (
            <SideBarFunction />
          )}
        </div>
        {this.props.route !== Routes.LOGIN && <FooterSection />}
        <Modal
          dialogClassName={styles.SymbolInfoModal}
          show={
            this.props.symbolInfoModal.show &&
            !this.props.location.pathname.includes(BoardRoutes.TRADING_TEMPLATE)
          }
          onHide={this.onCloseSymbolInfo}
          size="xl"
        >
          <SymbolInfo />
        </Modal>
        {/* Confirm Debt */}
        {this.props.confirmDebtModal.showConfirmDebtAfterCloseOtp &&
          isConsented && (
            <Modal
              className={classNames(styles.ConfirmDebtModal, 'newOTPModal')}
              // dialogClassName={classNames(styles.OtpOnceModalDialog)}
              show={this.props.confirmDebtModal.show}
              onHide={this.props.closeConfirmDebtModal}
              size={'sm'}
            >
              <div className={styles.Title}>{t('Confirm Debt')}</div>
              <span>{t('Please confirm your debt to continue')}</span>
              <div className={styles.ModalButtonSection}>
                <button
                  className={styles.CancelButton}
                  onClick={this.props.closeConfirmDebtModal}
                >
                  {t('Cancel')}
                </button>
                <Link
                  to={`/${Routes.ACCOUNT}/${AccountRoutes.LOAN_DETAIL}`}
                  className={styles.SubmitButton}
                  onClick={this.props.closeConfirmDebtModal}
                >
                  {t('Go to confirm debt')}
                </Link>
              </div>
            </Modal>
          )}
        {this.props.otpToken == null && isConsented && (
          <OtpModal
            size="sm"
            show={this.props.otp.showOtpForm}
            onHide={this.onCloseOtpModal}
            isAfterLoginOtp={true}
            className="newOTPModal"
            dialogClassName={styles.OrderFormDialog}
          />
        )}

        {this.props.confirmDebtModal.showPopUp &&
          !this.props.confirmDebtModal.showConfirmDebtAfterCloseOtp &&
          isConsented &&
          dataPopUpto.listBanner.length > 0 && (
            <ModalSlider
              className={styles.PopUpModal}
              show={this.state.isShowPopUps}
              onHide={this.handleClosePopUp}
              onShow={this.handleShowPopup}
              size={'lg'}
              data={dataPopUpto}
              selectedAccount={this.props.selectedAccount?.account}
              currentLang={this.props.lang}
            ></ModalSlider>
          )}
        {this.state.isShowPolicy && isAuthenticated && (
          <>
            <Modal
              className={classNames(styles.PolicyModal)}
              show={this.state.isShowPolicy}
              onHide={this.props.closeConfirmDebtModal}
            >
              <div>
                <PolicyBanner />
              </div>
              <div className={styles.Title}>
                {t('Personal data protection and processing policy')}
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: t(`PolicyContent`),
                }}
              ></div>
              <div className={styles.ModalButtonSection}>
                <button
                  className={styles.SubmitButton}
                  onClick={this.doConsent}
                >
                  {t('I agree')}
                </button>
              </div>
            </Modal>
            {/* policyDetail */}
            <Modal
              className={classNames(styles.PolicyModalDetail)}
              show={this.state.isShowPolicyDetail}
              onHide={() => this.setState({ isShowPolicyDetail: false })}
            >
              <div className={styles.Title}>
                {t('Personal data protection and processing policy')}
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: t(`PolicyContentDetail`) }}
              ></div>
              <div className={styles.ModalButtonSection}>
                <button
                  className={styles.SubmitButton}
                  onClick={this.doConsent}
                >
                  {t('I agree')}
                </button>
              </div>
            </Modal>
          </>
        )}
      </main>
    );
  }

  private doConsent = () => {
    const {
      clientDetail: { customerProfile },
    } = this.props;

    const params: IDoConsentParams = {
      email: customerProfile?.email ?? '',
      idCard: customerProfile?.IDNumberPassport ?? '',
      deviceId: this.state.deviceIp,
      phone: customerProfile?.mobilePhone ?? '',
    };

    this.props.doConsent(params);
  };

  private getInfoPopUp() {
    if (config.popUpUrl != null) {
      fetch(config.popUpUrl, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
          Timeout: '5000',
        },
      })
        .then((response) => {
          if (!response.ok) {
            // *** Check errors
            throw new Error('HTTP status ' + response.status);
          }
          return response.text(); // *** Read the TEXT of the response
        })
        .then((dataSourceText) => {
          // *** More accurate name
          const dataSource: IPopUpData = JSON.parse(dataSourceText);
          this.props.dispatchPopUptoStore(this.handlePeriodPopup(dataSource));
        })
        .catch((error) => {
          console.log('Please check your internet connection then try again!');
        });
    }
  }

  private handlePeriodPopup(data: IPopUpData): IPopUpData {
    const filterData = data.listBanner.filter(
      (val) =>
        dateFns.isBefore(Date.parse(val.period.startDate), new Date()) &&
        dateFns.isBefore(new Date(), Date.parse(val.period.endDate))
    );
    return { ...data, listBanner: filterData };
  }

  private onCloseOtpModal = () => {
    this.props.closeOtpModal();
    this.props.closeOtpModalAndTriggerConfirmDebt();
  };
  private handleClosePopUp = () => {
    this.props.closePopUpSlideModal();
    this.setState({ isShowPopUps: false });
  };

  private handleShowPopup = () => {
    this.setState({ isShowPopUps: true });
  };

  private onCloseSymbolInfo = () => {
    this.props.toggleSymbolInfoModal({ show: false });
  };
}

const mapStateToProps = (state: IState) => ({
  otp: state.otp,
  otpToken: state.otpToken,
  symbolInfoModal: state.symbolInfoModal,
  isAuthenticated: state.isAuthenticated,
  config: state.config,
  selectedAccount: state.selectedAccount,
  equityConfirmDebt: state.equityConfirmDebt,
  confirmDebtModal: state.confirmDebtModal,
  dataPopUpto: state.dispatchPopUptoStore,
  lang: state.lang,
  limitDateQuery: state.limitDateQuery,
  wordBannerQuery: state.wordBannerQuery,
  isConsent: state.isConsent,
  clientDetail: state.clientDetail,
  marketStatus: state.marketStatus,
  tokenCA: state.tokenCA,
  doConsentResult: state.doConsentResult,
});

const mapDispatchToProps = {
  setCurrentSymbol,
  changeRoute,
  toggleSymbolInfoModal,
  closeOtpModal,
  queryEquityConfirmDebt,
  closeConfirmDebtModal,
  closeOtpModalAndTriggerConfirmDebt,
  dispatchPopUptoStore,
  closePopUpSlideModal,
  queryLimitDate,
  queryWordBanner,
  checkConsent,
  queryClientDetail,
  showNotification,
  resetConsent,
  getBuyInStockList,
  registerTokenCA,
  getTokenCA,
  doConsent,
};

const Layout = withRouter(
  withErrorBoundary(
    withNamespaces(['common'], { wait: true })(
      connect(mapStateToProps, mapDispatchToProps)(LayoutComponent)
    ),
    Fallback,
    handleError
  )
);

export default Layout;



// WEBPACK FOOTER //
// ./src/components/common/Layout/index.tsx